export default "/assets/images/apple-store.6be3e941df6ed728.svg";